<template>
	<div class="gantt-time-board-list" style="transition:1s">
		<Dialog
			:dialog="dialog" 
			@agree="onClickAgree"
			@disagree="onClickDisagree"
		/>
		<TLHeader
			:items="dataItem"
			:selected_member_code="$store.getters['list/targetMember']"
			v-on:show-rightpane-memberlist="showRightPaneMemberList"
			v-on:move-my-page="moveMyPage"
		/>
		<TLHeaderCalendar />
		<div class="tl-body-wrap" :style="styleContentWidth">
			<div class="tl-body" :style="styleContentHeight">
				<TLTaskList 
					:items="items"
					:schedules="schedules"
					:selected_member_code="$store.getters['list/targetMember']"
					v-on:show-project-task-list="onClickShowProjectTaskList"
					v-on:show-task-info="showRightPaneTaskInfo"
				/>
			</div>
			<v-btn
				fixed
				dark
				fab
				bottom
				right
				color="pink"
				v-on:click.stop="onClickAddTask"
				class="add-task-btn"
			>
				<v-icon>add</v-icon>
			</v-btn>
		</div>
		<RightPaneMemberList
			v-bind:value="right_pane.member_list"
			v-on:close="onCloseRightPane('member_list');"
			v-on:member-selected="onClickMemberSelected"
			v-on:show-member-info="showRightPaneMemberInfo"
		/>
		<RightPaneProjectList
			v-bind:value="right_pane.project_list"
			v-on:project-selected="onSelectProject"
			v-on:close="onCloseRightPane('project_list');"
		/>
		<RightPaneMemberInfo
			v-bind:value="right_pane.member_info"
			v-on:close="onCloseRightPane('member_info');"
			v-on:update-task="onUpdateTask"
			v-on:delete-task="onDeleteTask"
		/>
		<RightPaneTaskInfo
			v-bind:value="right_pane.task_info"
			v-on:close="onCloseRightPane('task_info');"
			v-on:show-rightpane-projectlist="showRightPaneProjectList"
			v-on:show-rightpane-memberlist="showRightPaneMemberList"
			v-on:update-task="onUpdateTask"
			v-on:delete-task="onDeleteTask"
		/>
	</div>
</template>
<script>
import TLHeader from './TLHeader';
import TLHeaderCalendar from './TLHeaderCalendar';
import TLTaskList from './TLTaskList';
import RightPaneMemberList from '../RightPaneMemberList';
import RightPaneProjectList from '../RightPaneProjectList';
import RightPaneTaskInfo from '../RightPaneTaskInfo';
import RightPaneMemberInfo from '../RightPaneMemberInfo';
import Dialog from '../Dialog';

import clonedeep from 'lodash/cloneDeep';
import { DISPLAY_LIST_TYPE, FORM_MODE } from '../../classes/Const';
import Util from '../../classes/Util';

const uuidv4 = require('uuid/v4');

export default {
	name: "GanttTimeBoardList",
	data () {
		return {
			right_pane: {
				member_list :null,
				project_list : null,
				task_info :null,
				member_info: null,
			},
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
		}
	},
	components: {
		TLHeader,
		TLHeaderCalendar,
		TLTaskList,
		RightPaneMemberList,
		RightPaneProjectList,
		RightPaneTaskInfo,
		RightPaneMemberInfo,
		Dialog,
	},
	methods: {
		onCloseRightPane: function(name) {
			if (this.right_pane[name]) {
				this.right_pane[name] = null;
			}
		},

		showRightPaneMemberList: function (e){
			this.right_pane.member_list = clonedeep(e);
		},
		showRightPaneMemberInfo: function(e){
			this.right_pane.member_info = clonedeep(e);
			
			
			
			
			this.right_pane.member_info = {
				member: clonedeep(e),
				mode: e.code === this.$store.getters['loginUser'].code ? FORM_MODE.EDIT : FORM_MODE.REFERENCE,
			};
			
			
			
			
		},
		showRightPaneProjectList: function(e){
			this.right_pane.project_list = clonedeep(e);
		},
		showRightPaneTaskInfo: function(e) {
			this.right_pane.task_info = clonedeep(e);
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.commit('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
					client_width: document.documentElement.clientWidth,
					client_height: document.documentElement.clientHeight,
				});
			});
		},
		onClickMemberSelected: function(e) {
			if (this.right_pane.task_info) {
				this.right_pane.task_info.task.member_code = e;
			} else {
				this.$store.commit('list/setTargetMember', e);
				if (!this.$store.getters['list/isDisplayMemberList'])
					this.$store.dispatch('list/setDisplayListTypeMember');
			}
			this.onCloseRightPane('member_list');
		},
		onSelectProject: function(e) {
			this.right_pane.task_info.task.project_code = e;
			this.onCloseRightPane('project_list');
		},
		onClickShowProjectTaskList: function(e) {
			this.$store.commit('list/setTargetProject', e);
		},
		moveMyPage: function() {
			this.$store.commit('list/setTargetMember', this.$store.getters['loginUser'].code);
			if (!this.$store.getters['list/isDisplayMemberList'])
				this.$store.dispatch('list/setDisplayListTypeMember');
		},
		onClickAddTask: function() {
			let task_code = uuidv4();
			if (this.isDisplayMemberList) {
				this.$store.dispatch('addTask', {
					task_code: task_code,
					member_code: this.$store.getters['list/targetMember'],
				}).then(() =>{
					let task = this.$store.getters.task(task_code);
					if (task) {
						this.showRightPaneTaskInfo({
							task: task,
							mode: FORM_MODE.ENTRY,
							display_type: DISPLAY_LIST_TYPE.MEMBER,
						});
					}
				});
			} else {
				let schedules = undefined;
				let project = clonedeep(this.$store.getters.project(this.target_project));
				if (project) {
					schedules = project.schedules;
					schedules.forEach( s => {
						s.code = uuidv4();
						s.task_code = task_code;
						s.project_code = this.target_project;
						s.member_code = '';
					});
				}
				this.$store.dispatch('addTask', {
					task_code: task_code,
					project_code: this.$store.getters['list/targetProject'],
					schedules: schedules,
				}).then(() =>{
					let task = this.$store.getters.task(task_code);
					if (task) {
						this.showRightPaneTaskInfo({
							task: task,
							mode: FORM_MODE.ENTRY,
							display_type: DISPLAY_LIST_TYPE.PROJECT,
						});
					}
				});
			}
		},
		onUpdateTask: function(e) {
			this.$store.dispatch('updateDataTask', e).then((res) => {
				if (!res)
					this.displayErrorDialog('更新対象が削除されています');
			});
		},
		onDeleteTask: function(code) {
			this.$store.dispatch('deleteDataTask', code).then((res) => {
				if (!res)
					this.displayErrorDialog('更新対象が削除されています');
			});
		},
		displayErrorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		displayConfirmationDialog: function(text, agree) {
			this.dialog.title = '確認';
			this.dialog.text = text;
			this.dialog.disagree = () => {
				this.dialog.display = false;
			};
			this.dialog.agree = agree;
			this.dialog.display = true;
		},
		onClickDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
	},
	computed: {
		items: function() {
			if (this.isDisplayMemberList)
				return this.$store.getters['list/display_list'](this.$store.getters['list/targetMember']);
			else 
				return this.$store.getters['list/display_list'](this.$store.getters['list/targetProject']);
		},
		dataItem: function() {
			if (this.isDisplayMemberList)
				return this.$store.getters['member'](this.$store.getters['list/targetMember']);
			else 
				return this.$store.getters['project'](this.$store.getters['list/targetProject']);
		},
		schedules: function() {
			let schedules = new Array();
			if (!this.items || this.items.length == 0)
				return schedules;
				
			if (this.isDisplayMemberList)
				schedules = this.items.schedules;
			else
				this.items.children.forEach(t => {
					t.schedules.forEach(s => {
						schedules.push(s);
					});
				});
			
			return schedules;
		},
		isDisplayMemberList: function() {
			return this.$store.getters['list/isDisplayMemberList'];
		},
		styleContentWidth: function() {
			return {
				width: this.$store.getters.clientWidth + 8 + 'px',
			};
		},
		styleContentHeight: function() {
			let header = 60;
			let header_calendar = 30;
			
			return {
				height: this.$store.getters.windowHeight - header - header_calendar + 'px',
			};
		},
	},
	watch: {
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);

		this.onWindowResize();
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
	},
	mounted: function() {
	}
};
</script>
<style>
	.gantt-time-board-list {
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #ededed;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		overflow: hidden;
		transition:1s;
	}
	.tl-body-wrap{
		z-index: 100;
		overflow-y: hidden;
		overflow-x: hidden;
	}
	.tl-body {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
		padding-bottom: 90px;
	}
	.gantt-time-board-list .add-task-btn {
		z-index: 101;
	}
</style>
